module.exports = __webpack_public_path__ + "static/media/movies.719671a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/movies.jpg
// module id = 192
// module chunks = 0